export const GET_CUSTOMERS = "GET_CUSTOMERS";
export const GET_CUSTOMER_BY_ID = "GET_CUSTOMER_BY_ID";
export const GET_CUSTOMER_FULL = "GET_CUSTOMER_FULL";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const DELETE_CUSTOMER = "DELETE_CUSTOMER";
export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
